import useLang from "../../../hooks/useLang";
import Icon from "../../../components/Icon";
import classNames from "classnames";
import styles from "./token.module.css";

const Token = ({ token, constants, onDelete }) => {
  const lang = useLang();
  const label =
    token?.type === "CONSTANT"
      ? constants?.find((c) => c?.id === token?.value)?.label || token?.value
      : token?.type === "NUMBER"
        ? String(token?.value)
        : lang(token?.value);

  return (
    <div
      className={classNames(
        styles.token,
        styles[token?.type?.toLowerCase()],
        styles.tokenContainer, // new: for positioning/hover
      )}
      title={`${token.type}: ${token.value}`}
      tabIndex={0}
      onKeyDown={(e) => {
        if ((e.key === "Backspace" || e.key === "Delete") && onDelete) {
          e.stopPropagation();
          onDelete?.();
        }
      }}
    >
      <span className={styles.label}>{label}</span>
      {typeof onDelete === "function" ? (
        <button
          type="button"
          data-nodrag
          className={styles.deleteBtn}
          aria-label={`Remove ${label}`}
          title="Remove"
          onPointerDown={(e) => e.stopPropagation()} // prevents drag initiation
          onClick={(e) => {
            e.stopPropagation();
            onDelete?.();
          }}
        >
          <Icon trashIcon size={16} style={{ pointerEvents: "none" }} />
        </button>
      ) : null}
    </div>
  );
};

export default Token;
